// ✅ src/services/roleMasterService.js
import axiosClient from "../api/axiosClient";

// ✅ GET list — ensure array return
export const rm_list = async (params = {}) => {
  try {
    const res = await axiosClient.get("/rolesmaster/platform/api/list", { params });
    return {
      success: true,
      data: Array.isArray(res?.data?.data) ? res.data.data : [],
    };
  } catch (err) {
    console.error("Role list fetch failed:", err);
    return { success: false, data: [] };
  }
};

// ✅ Create role — return success state
export const rm_create = async (payload) => {
  try {
    const res = await axiosClient.post("/rolesmaster/platform/api/create", payload);
    return { success: true, data: res.data };
  } catch (err) {
    console.error("Role create failed:", err);
    return { success: false };
  }
};

// ✅ Get role detail
export const rm_get = async (id) => {
  try {
    const res = await axiosClient.get(`/rolesmaster/platform/api/${id}`);
    return res.data;
  } catch (err) {
    console.error("Role fetch failed:", err);
    return null;
  }
};

// ✅ Update role
export const rm_update = async (id, payload) => {
  try {
    const res = await axiosClient.put(`/rolesmaster/platform/api/${id}`, payload);
    return { success: true, data: res.data };
  } catch (err) {
    console.error("Role update failed:", err);
    return { success: false };
  }
};

// ✅ Patch status change
export const rm_set_status = async (id, status) => {
  try {
    const res = await axiosClient.put(`/rolesmaster/platform/api/${id}/status`, { status });
    return { success: true, data: res.data };
  } catch (err) {
    console.error("Role status change failed:", err);
    return { success: false };
  }
};
